import React, { useEffect, useContext } from "react";
import { Redirect } from "react-router-dom";
import axios from "axios";

import config from "../../dashboard-config";
import { SessionContext } from "../../context/SessionContext";

const Logout: React.FC<{}> = () => {
  const { currentSession, setCurrentSession } = useContext(SessionContext);

  useEffect(() => {
    localStorage.removeItem("sofar-user");
    setCurrentSession((s: any) => ({ ...s, isLogged: false }));
  }, [currentSession, setCurrentSession]);

  return <Redirect to="/login" />;
};

export default Logout;
